/* eslint-disable react/jsx-key */
import * as React from 'react';
import { IconCheck } from '../../../components/complaint/feedback_form/icons';

import * as styles from './index.css';

interface IChecklistProps {
  items: string[];
  icon?: React.ComponentType;
}

export function Checklist({ items, icon }: IChecklistProps) {
  const DefaultIcon = icon ? icon : IconCheck;

  return (
    <ul className={styles['checklist']}>
      {items.map(item => (
        <li className={styles['item']}>
          <DefaultIcon />
          &nbsp;{item}
        </li>
      ))}
    </ul>
  );
}
